import WorkoutProgressionBadge from './WorkoutProgressionBadge';

export default WorkoutProgressionBadge;
